module.exports = __webpack_public_path__ + "11734e6b49ffa6a8c4bdd75c5d4afd1c.png";